module.exports = __webpack_public_path__ + "static/media/윤정현.2e8a56bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/윤정현.png
// module id = 108
// module chunks = 0